const checkSubstring = (inputString) => {
  if (inputString && inputString.includes("msafety")) {
    return "msafety";
  } else {
    return inputString;
  }
};

class TenantExtractor {
  static get regexPattern() {
    return /^(\w+)-([\w-]+)(\..*)?$/;
  }
  static get regexPatternForNewBaseUrl() {
    return /^(\w+)\.(\w+)(\..*)?$/;
  }
  static getHostname() {
    return window.location.hostname;
  }
  static isNewBaseUrl() {
    return this.regexPatternForNewBaseUrl.test(this.getHostname());
  }
  static getMatch() {
    return this[this.isNewBaseUrl() ? "regexPatternForNewBaseUrl" : "regexPattern"].exec(this.getHostname());
  }

  static parseTenantAndProduct() {
    const match = this.getMatch() ?? [];
    const isNew = this.isNewBaseUrl();
    return {
      tenant: match[isNew ? 1 : 2],
      product: match[isNew ? 2 : 1],
    };
  }

  static getTenant() {
    try {
      const { tenant } = this.parseTenantAndProduct();
      if (tenant) {
        if (["dev", "sales", "devm", "qa"].includes(tenant)) {
          return null;
        }
        return tenant;
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  static getProduct() {
    try {
      const { product } = this.parseTenantAndProduct();
      return checkSubstring(product) || null;
    } catch (error) {
      return null;
    }
  }
}

export default TenantExtractor;
